import { XmarkCircle } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const CrossCircleIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <XmarkCircle width={size} height={size} color={color} {...rest} />;

CrossCircleIcon.displayName = 'CrossCircleIcon';
export default CrossCircleIcon;
